<template>
  <component :is="layout" />
</template>

<script lang="ts">
import Vue from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import MainLayout from '@/views/layouts/MainLayout.vue'
import LoginLayout from '@/views/layouts/LoginLayout.vue'
import InfoLayout from '@/views/layouts/InfoLayout.vue'
import { DevicesResponse } from '@/store/signin/types'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/messaging'
import { NotificationType, showNotification } from '@/utils/Notification'
import { DeviceRequest, DoctorPayload } from '@/store/doctor/types'
import UserStorage from '@/utils/Storage/UserStorage'
const userStorage = UserStorage.getInstance()

export default Vue.extend({
  name: 'App',

  components: {
    MainLayout,
    LoginLayout,
    InfoLayout
  },

  computed: {
    ...mapState(['layout']),
    ...mapState('patients', ['patientDetail'])
  },

  methods: {
    ...mapActions('chat', ['getMessages']),
    ...mapActions('notifications', ['getNotifications']),
    ...mapMutations('notifications', ['SET_LOADER']),
    ...mapActions('signIn', ['registerDevice', 'getDevices']),
    ...mapMutations('signIn', ['SET_DEVICEID']),
    ...mapGetters(['isAuthenticated']),

    async requestNotificationPermission() {
      const permiss = await Notification.requestPermission()
      if (permiss === 'granted') {
        this.getMessagingToken()
      } else {
        this.$buefy.notification.open({
          message:
            'Para recibir notificaciones concede el permiso en el navegador',
          position: 'is-top',
          type: 'is-danger is-light',
          duration: 3000
        })
      }
    },

    getMessagingToken() {
      const messaging = firebase.messaging()

      messaging
        .getToken()
        .then(async token => {
          if (token) {
            const deviceRequest = {
              deviceId: token,
              deviceType: 'PWA'
            } as DeviceRequest
            const request = {
              entityId: 1, //this.doctor.doctorId,
              payload: deviceRequest
            } as DoctorPayload<DeviceRequest>
            let actualDeviceId = await this.getDeviceId(token)
            if (actualDeviceId == 0) {
              await this.registerDevice(request)
              actualDeviceId = await this.getDeviceId(token)
            }
            await this.SET_DEVICEID(actualDeviceId)
            this.getNotifications()
          }
        })
        .catch(function (err) {
          console.log('An error occurred while retrieving token. ', err)
        })
    },

    async getDeviceId(token: string) {
      let devices = await this.getDevices()
      let actualDivece = devices?.find(
        (x: DevicesResponse) => x.deviceId === token
      )
      return actualDivece?.id ?? 0
    }
  },

  created() {
    const isAuthenticated = !!userStorage.getTokenId()
    if (isAuthenticated) {
      this.requestNotificationPermission()
    }
    const messaging = firebase.messaging()
    messaging.onMessage(payload => {
      const { body } = payload.notification
      showNotification(NotificationType.INFO, body)

      this.getNotifications()
    })
  }
})
</script>

<style lang="sass" scoped>
@import @/assets/sass/style
</style>
